<cli-topbar></cli-topbar>
<cli-navbar *ngIf="!vm.isOpening" [selectedSection]="'vehicles'" [businessName]="vm.businessName"
  [permitNo]="vm.permitNo"></cli-navbar>
<core-spinner *ngIf="vm.isLoading"></core-spinner>
<div class="container" *ngIf="!vm.isOpening">
  <div class="row ">
    <div class="col pt-4 section-header" *ngIf="vm.isNew">Add New Vehicle</div>
    <div class="col pt-4 section-header" *ngIf="!vm.isNew">Edit Vehicle</div>
  </div>
  <div>
    <hr class="mt-0 mb-1" />
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-8 col-sm-12">
      <form>

        <div class="row pb-1">
          <div class="col-md-6">
            <label>Registration No *</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('regoNo')}" name="regoNo"
              placeholder="" type="text" [(ngModel)]="vm.regoNo" (keyup)="onRegoChanged()"
              (paste)="onRegoChanged()">
            <div class="invalid-feedback"> {{error('regoNo')}} </div>

          </div>
          <div class="col-md-3">
            <label>State *</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('state')}" name="state"
              placeholder="" type="text" [(ngModel)]="vm.state" (keyup)="onRegoChanged()"
              (paste)="onRegoChanged()">
            <div class="invalid-feedback"> {{error('state')}} </div>

          </div>
          <div class="col-md-3">
            <label>Capacity, Litres*</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('capacity')}"
              name="capacity" placeholder="" type="text" [(ngModel)]="vm.capacity">
            <div class="invalid-feedback"> {{error('capacity')}} </div>
          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6">
            <label>Vehicle Type *</label>

            <select class=" form-control" [ngClass]="{'is-invalid': !!error('vehicleTypeId')}"
              name="vehicleTypeId" [(ngModel)]="vm.vehicleTypeId">
              <option [ngValue]="0"></option>
              <option *ngFor="let c of vm.vehicleTypes" [ngValue]="c.vehicleTypeId">
                {{c.description}}</option>
            </select>
            <div class="invalid-feedback"> {{error('vehicleTypeId')}} </div>

          </div>

          <div class="col-md-6">
            <label>Vehicle Make *</label>
            <select class="form-control" [ngClass]="{'is-invalid': !!error('vehicleMakeId')}"
              name="vehicleMakeId" [(ngModel)]="vm.vehicleMakeId">
              <option [ngValue]="0"></option>
              <option *ngFor="let c of vm.vehicleMakes" [ngValue]="c.vehicleMakeId">
                {{c.description}}</option>
            </select>
            <div class="invalid-feedback"> {{error('vehicleMakeId')}} </div>

          </div>
        </div>

        <div class="row pb-1">
          <div class="col-md-6">
            <label>Vehicle is fitted with backflow prevention device?</label>

            <div>
              <div class="form-check-inline">

                <input class="form-check-input" type="radio" name="isBackflowPreventionDeviceSetup"
                  id="isBackflowPreventionDeviceSetup1" style="cursor:pointer;"
                  [ngClass]="{'is-invalid': !!error('isBackflowPreventionDeviceSetup')}" [value]="true"
                  [(ngModel)]="vm.isBackflowPreventionDeviceSetup">
                <span>Yes</span>

              </div>
              <div class="form-check-inline">
                <input class="form-check-input" type="radio" (click)="clearDevices()"
                  name="isBackflowPreventionDeviceSetup" id="isBackflowPreventionDeviceSetup2"
                  style="cursor:pointer;" [ngClass]="{'is-invalid': !!error('isBackflowPreventionDeviceSetup')}"
                  [value]="false" [(ngModel)]="vm.isBackflowPreventionDeviceSetup">
                <span>No</span>

              </div>

            </div>
            <div>
              <input class="form-check-input" type="hidden"
                [ngClass]="{'is-invalid': !!error('isBackflowPreventionDeviceSetup')}">
              <div class="invalid-feedback">{{error('isBackflowPreventionDeviceSetup')}}</div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="vm.isBackflowPreventionDeviceSetup">
            <label>Backflow prevention device </label>

            <div>
              <div class=" form-check">
                <input [disabled]="!vm.isBackflowPreventionDeviceSetup" style="cursor:pointer;" 
                class="form-check-input"
                  name="isRPZD" type="checkbox" [value]="true" [(ngModel)]="vm.isRPZD">
                <span>Reduced pressure zone device</span>
              </div>

              <div class="form-check">
                <input [disabled]="!vm.isBackflowPreventionDeviceSetup" style="cursor:pointer;" 
                class="form-check-input"
                 name="isAirGap" type="checkbox" [value]="true" [(ngModel)]="vm.isAirGap">
                <span>Air gap</span>
              </div>

              <div>
                <input class="form-check-input" type="hidden"
                  [ngClass]="{'is-invalid': !!error('backflowDeviceType')}">
                <div class="invalid-feedback">{{error('backflowDeviceType')}}</div>
              </div>

            </div>
          </div>
        </div>

        <div class="row pb-1" *ngIf="vm.isBackflowPreventionDeviceSetup">
          <div class="col-md-6">
            <label>The backflow prevention device is tested and certified?</label>

            <div>

              <div class="form-check-inline">
                <input class="form-check-input" type="radio"
                  name="isBackflowPreventionDeviceCertified" id="isBackflowPreventionDeviceCertified"
                  style="cursor:pointer;" [ngClass]="{'is-invalid': !!error('isBackflowPreventionDeviceCertified')}"
                  [value]="true" [(ngModel)]="vm.isBackflowPreventionDeviceCertified">
                <span>Yes</span>
              </div>

              <div class="form-check-inline">
                <input class="form-check-input" type="radio" (click)="clearCerfiticate()"
                  name="isBackflowPreventionDeviceCertified" id="isBackflowPreventionDeviceCertified2"
                  style="cursor:pointer;" [ngClass]="{'is-invalid': !!error('isBackflowPreventionDeviceCertified')}"
                  [value]="false" [(ngModel)]="vm.isBackflowPreventionDeviceCertified">
                <span>No</span>
              </div>

            </div>
            <div>
              <input class="form-check-input" type="hidden"
                [ngClass]="{'is-invalid': !!error('isBackflowPreventionDeviceCertified')}">
              <div class="invalid-feedback">{{error('isBackflowPreventionDeviceCertified')}}</div>
            </div>
          </div>

          <div class="col-md-6" *ngIf="vm.isBackflowPreventionDeviceCertified">
            <label>Certificate issue date</label>
            <input class="form-control" [ngClass]="{'is-invalid': !!error('backflowPreventionCertificateIssueDate')}"
              name="backflowPreventionCertificateIssueDate" placeholder="dd/mm/yyyy" type="text"
              [(ngModel)]="vm.backflowPreventionCertificateIssueDate" ngbDatepicker #dExpiryDate="ngbDatepicker"
              (click)="dExpiryDate.toggle()">
            <div class="invalid-feedback"> {{error('backflowPreventionCertificateIssueDate')}} </div>
          </div>
        </div>

        <div class="row pb-1 pt-2" *ngIf="vm.isBackflowPreventionDeviceSetup && vm.isBackflowPreventionDeviceCertified">
          <div class="col-md-12">
            <label *ngIf="vm.isNew">Uploaded a copy of a certificate</label>
            <label *ngIf="!vm.isNew">Uploaded certificates</label>
            <div>
              <cli-file-upload  
                [allowComments]="false" 
                [objectId]="vm.vehicleId" 
                [objectType]="'Vehicle'"
                [fileList]="vm.fileList"  
                (fileUploaded)="onFileUploaded($event)"
                (fileRemoved)="onFileRemoved($event)">
              </cli-file-upload>
            </div>
            <div>
              <input class="form-check-input" type="hidden" [ngClass]="{'is-invalid': !!error('uploadCertificate')}">
              <div class="invalid-feedback">{{error('uploadCertificate')}}</div>
            </div>
          </div>
        </div>

        <div class="row pb-1" *ngIf="vm.isBackflowPreventionDeviceSetup === false">
          <div class="col pt-2">
            <div class="alert alert-primary">
              <strong>Warning</strong>
              <p>
                You will have 3 months grace period to install and certify an approved backflow prevention device
              </p>
            </div>
          </div>
        </div>

        <div class="row pb-1"
          *ngIf="!!vm.isBackflowPreventionDeviceSetup && vm.isBackflowPreventionDeviceCertified === false">
          <div class="col pt-2">
            <div class="alert alert-primary">
              <strong>Warning</strong>
              <p>
                You will have 3 months grace period to certify your backflow prevention device
              </p>
            </div>
          </div>
        </div>

        <div>
            <hr class="mt-0 mb-1" />
          </div>
          <div class="d-flex justify-content-end pb-4">
            <div><button type="button" class="btn btn-primary" (click)="proceedYes()">OK</button></div>
            <div><button type="button" class="btn btn-link" (click)="proceedCancel()">Cancel</button></div>
          </div>
      </form>
    </div>
  </div>
</div>